import { getSupabaseBaseUrl, getSupabasePublishableKey } from '@/lib/selfHostedUrls';
import { createGovernedBrowserClient } from './portalClientFactory';

const SUPABASE_URL = getSupabaseBaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getSupabasePublishableKey();

// Dedicated stateless client for explicitly anonymous flows such as public apply
// and pre-auth consent capture. This avoids inheriting a persisted user session.
export const anonSupabase = createGovernedBrowserClient(
  'anonymous',
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
);
